










import { tns } from "tiny-slider/src/tiny-slider";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
    components: {
        EstateCard: () => import("./card.vue")
    }
})
export default class EstatesSlider extends Vue {
    $refs!: Vue["$refs"] & {
        slider: HTMLElement;
    };

    slider: any = null;

    loading: boolean = false;

    params: SweepbrightParams = { per_page: 3, page: 0, is_project: false, sort: "putOnlineDateTime,asc" };

    estates: Estate[] = [];

    private mounted() {
        this.getEstates();
    }

    private getEstates() {
        this.loading = true;
        // @ts-ignore
        axios
            .get("/api/estates", { params: { ...this.params } })
            .then((response: any) => this.initSlider(response.data.data))
            .finally(() => (this.loading = false));
    }

    private initSlider(estates: Estate[]) {
        this.estates = estates;
        this.$nextTick(() => {
            this.slider = tns({
                container: this.$refs.slider,
                items: 1.2,
                gutter: 16,
                preventScrollOnTouch: "force",
                mouseDrag: true,
                loop: false,
                controls: false,
                nav: false,
                swipeAngle: false,
                responsive: {
                    1024: {
                        items: 3,
                        gutter: 32
                    }
                }
            });
        });
    }
}
